import { createValueFormatter, type ServerColDef } from '@cmg/data-grid';

import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';

export const valueFormatter = createValueFormatter<
  UnderwriterEmployeeFragment,
  UnderwriterEmployeeFragment['modifiedByUserName']
>();

const updatedByColDef: ServerColDef<UnderwriterEmployeeFragment> = {
  field: 'modifiedByUserName',
  headerName: 'Updated By',
  valueFormatter,
  minWidth: 180,
  filterParams: {
    filterOptions: ['equals', 'notEqual'],
  },
};

export default updatedByColDef;
